import React from 'react'

const SubRegister = () => {
  return (
    <div>SubRegister</div>
  )
}

export default SubRegister